// @flow
import moment from 'moment'

export default function asTimeStamp (format: string): (value: any) => ?number {
  return function (value: ?any): ?number {
    if (value != null) {
      const isTimeStamp = typeof value === 'number' || `${Number(value)}` === value
      const datetime = moment(`${value}`, isTimeStamp ? 'X' : format)

      if (datetime.isValid()) {
        return Number(datetime.format('X'))
      }
    }

    return null
  }
}
